import {DeleteFavoritePlaceServiceParams} from '../types';
import {makeDeleteFavoritePlace} from 'main/factories/usecases';

export async function deleteFavoritePlace({
  cdBeneficiarioEnderecoFavorito,
  signal,
}: DeleteFavoritePlaceServiceParams) {
  await makeDeleteFavoritePlace(cdBeneficiarioEnderecoFavorito)
    .delete({cdBeneficiarioEnderecoFavorito, signal});
}
